import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Container } from 'react-bootstrap';

import Breadcrumbs from './../block/Breadcrumbs'
import MemoizedHTML from './../block/MemoizedHTML'

import styles from './../style/Page.module.scss'

export default class Page extends Component {

  render() {

    const { ajax_data } = this.props

    return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />
        <section className={styles.section}>
          <Container className={styles.container}>
            <h1>{ajax_data?.pagetitle || ''}</h1>
            <MemoizedHTML html={ajax_data?.content || ''} />
          </Container>
        </section>
      </>
    )
  }
}

Page.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object
}